import React from 'react';
import { FieldToggle, FieldToggleProps } from '@spotify-internal/anchor-ds';
import { FieldController, HookFormProps } from 'shared/FieldController';

type ControlledFieldToggleProps = HookFormProps &
  Omit<FieldToggleProps, 'defaultValue'>;

export const ControlledFieldToggle = (props: ControlledFieldToggleProps) => (
  <FieldController<FieldToggleProps, HTMLInputElement>
    as={FieldToggle as any}
    {...props}
  />
);
